<form [formGroup]="dropdownForm">
    <div class="background" *ngIf="showDropdownMenu" (click)="toggleDropdown()"></div>
    <div
        class="dropdown"
        [ngClass]="{
            disabled: dropdownDisabled(),
            'readonly-input-control': isReadonlyInputControl,
        }"
        paceCoreValidationMessage
        [validation]="dropdownForm"
    >
        <div class="input-group">
            <div
                class="form-control flex-grow-1 dropdown-display"
                #dropDownButton
                *ngIf="!model.options.displayText"
                (click)="toggleDropdownFromMenu($event)"
                [ngClass]="{ 'is-invalid': !dropdownForm.valid }"
            >
                {{ model.selectedEntry ? model.selectedEntry.displayName : strings.placeholder }}
            </div>
            <input
                class="form-control input-md text-input"
                type="text"
                *ngIf="model.options.displayText"
                formControlName="dropdownTextInputControl"
                [placeholder]="model.options.placeholder"
                (click)="toggleDropdownFromMenu($event)"
                (input)="clearDropdownSelection($event)"
                [ngClass]="{
                    'ng-invalid': dropdownTextInputControl.invalid,
                    'is-valid': dropdownTextInputControl.valid,
                }"
                paceCoreTextInputRestriction
            />
            <ng-container *ngIf="model.options.scannable">
                <button class="btn btn-secondary" type="button" (click)="doScan()">
                    <fa-icon [icon]="faBarcode" size="2x"></fa-icon>
                </button>
            </ng-container>
            <div class="d-flex" (click)="toggleDropdownFromMenu($event)" *ngIf="model.value.length > 0">
                <fa-icon [icon]="faCaretDown" class="input-group-text"></fa-icon>
            </div>
            <span class="sr-only">Toggle Dropdown</span>
        </div>
        <ul
            class="dropdown-menu"
            #dropDownMenu
            role="menu"
            [ngClass]="{ show: showDropdownMenu }"
            *ngIf="model.value.length > 0"
        >
            <li role="menuitem">
                <input
                    type="text"
                    formControlName="searchInput"
                    *ngIf="model.value.length > 3"
                    (click)="$event.stopPropagation()"
                    class="form-control"
                    [placeholder]="strings.searchPlaceholder"
                />
            </li>
            <li role="menuitem" *ngFor="let entry of searchMatchingEntries">
                <a
                    class="dropdown-item"
                    (click)="onSelected(entry)"
                    [ngClass]="{ 'highlight-selection': isSelected(entry) }"
                    >{{ entry.displayName }}</a
                >
            </li>
        </ul>
    </div>

    <ul class="tags" *ngIf="model.options.maxSelections > 1 && model.selectedEntries.length > 0">
        <li *ngFor="let entry of model.selectedEntries" (click)="onSelected(entry)">
            {{ entry.displayName }}
            <span *ngIf="!model.options.alwaysSelectedEntries.includes(entry.value)">
                <fa-icon class="mx-1" [icon]="faTimes"></fa-icon>
            </span>
        </li>
    </ul>
</form>
